import React, { Component } from 'react';
//import logo from './logo.svg';
import img from './virus.png'
import './App.css';
import ParticlesBg from 'particles-bg'
import Particles from 'react-particles-js';



class App extends React.Component{

  constructor(){
    super();

    this.state = {
      covidData: []
        
    }
  }
 
  componentDidMount(){
    fetch('https://hpb.health.gov.lk/api/get-current-statistical')
    .then(Response => Response.json())
    .then(users =>{
      console.log(users);
      this.setState({
        covidData: users.data
        
      })

    }) 
    
  }

 

      render(){

          
        return(
          <div className="App">
              
              <div>
                  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
                  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous"></link>
                  <link href="https://fonts.googleapis.com/css?family=Baloo+Da+2&display=swap" rel="stylesheet"></link>

                    <nav class="navbar navbar-light bg-light">
                      <div class="container-fluid">
                        <div class="navbar-header">
                           <a class="navbar-brand" href="#"><h1>COVID-19 Sri Lanka Tracker</h1></a>
                            <img src={img}  width="50" height="50" /> 
                        </div>
                      </div>
                    </nav>

                    <br/><br/>
                    
                  <div class="container pt-3">
                    
                    
                    <p>Latest Updated Time and Date : {this.state.covidData.update_date_time}></p>
                    <br/>
                    <h1>Sri Lanka Cases Details</h1>
                    <br/>
                      <div class="row justify-content-center">
                      <div class="col-md-3 col-sm-6" >
                          <div class="card text-white  bg-info mb-3">
                            <div class="card-header border">New Cases</div>
                            <div class="card-body border">
                              <h1><span class="fa fa-hospital-o"></span></h1>
                              <h1 class="card-title">New Patients</h1>
                              <h1 class="card-text ">{this.state.covidData.local_new_cases}</h1>
                          </div> 
                        </div>
                      </div>

                        <div class="col-md-3 col-sm-6">
                          <div class="card text-white bg-danger mb-3">
                            <div class="card-header">Total Infected Count</div>
                            <div class="card-body">
                              <h1><span class="fa fa-ambulance"></span></h1>
                              <h1 class="card-title">Confirmed Patients</h1>
                              <h1 class="card-text ">{this.state.covidData.local_total_cases}</h1>
                          </div> 
                        </div>
                      </div>

                      <div class="col-md-3 col-sm-6">
                          <div class="card text-white bg-warning mb-3">
                            <div class="card-header">Total Death Count</div>
                            <div class="card-body">
                              <h1><span class="fa fa-frown-o"></span></h1>
                              <h1 class="card-title">Confirmed Deaths</h1>
                              <h1 class="card-text ">{this.state.covidData.local_deaths}</h1>
                          </div> 
                        </div>
                      </div>

                      <div class="col-md-3 col-sm-6">
                          <div class="card text-white bg-success mb-3">
                            <div class="card-header">Total Cured Count</div>
                            <div class="card-body">
                              <h1><span class="fa fa-medkit"></span></h1>
                              <h1 class="card-title">Cured Patients</h1>
                              <h1 class="card-text ">{this.state.covidData.local_recovered}</h1>
                          </div> 
                            
                        </div>
                      </div>
                </div>
                <h1>Global Cases Details</h1>
                <br/>
                <div class="row justify-content-center">
                  <div class="col-md-3 col-sm-6" >
                          <div class="card text-white  bg-info mb-3">
                            <div class="card-header border">Gloabal New Cases</div>
                            <div class="card-body border">
                              <h1><span class="fa fa-hospital-o"></span></h1>
                              <h1 class="card-title">New Patients</h1>
                              <h1 class="card-text ">{this.state.covidData.global_new_cases }</h1>
                          </div> 
                        </div>
                      </div>

                        <div class="col-md-3 col-sm-6">
                          <div class="card text-white bg-danger mb-3">
                            <div class="card-header">Total Infected Count</div>
                            <div class="card-body">
                              <h1><span class="fa fa-ambulance"></span></h1>
                              <h1 class="card-title">Confirmed Cases</h1>
                              <h1 class="card-text ">{this.state.covidData.global_total_cases}</h1>
                          </div> 
                        </div>
                      </div>

                      <div class="col-md-3 col-sm-6">
                          <div class="card text-white bg-warning mb-3">
                            <div class="card-header">Global Death Count</div>
                            <div class="card-body">
                              <h1><span class="fa fa-frown-o"></span></h1>
                              <h1 class="card-title">Total Deaths</h1>
                              <h1 class="card-text ">{this.state.covidData.global_deaths}</h1>
                          </div> 
                        </div>
                      </div>

                      <div class="col-md-3 col-sm-6">
                          <div class="card text-white bg-success mb-3">
                            <div class="card-header">Total Cured Count</div>
                            <div class="card-body">
                              <h1><span class="fa fa-medkit"></span></h1>
                              <h1 class="card-title">Total Cured Patients</h1>
                              <h1 class="card-text ">{this.state.covidData.global_recovered}</h1>
                          </div> 
                        </div>
                      </div>

                      
                

                </div>
                <div class="row justify-content-center">
                
                  
                    

                 
                      
                      
                        

                     

                      
                

                </div>

               
                
              
                      
               </div>
           </div>
           <ParticlesBg  num={50} type="cobweb" bg={true}/>
       </div>
        
    );

        
  }
 
}
export default App;
